import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKenkoSindanKanriGetRes,
  TKenkoSindanKanriListGetReq,
  TKenkoSindanKanriListGetRes,
  TKenkoSindanKanriPostReq,
  TKenkoSindanKanriPutReq,
} from "./TKenkoSindan"

/**
 * 健康診断に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class KenkoSindanService extends ConnectApi {
  /**
   * 健康診断管理情報一覧取得
   *
   * @param {TKenkoSindanKanriListGetReq} params
   * @memberof KenkoSindanService
   */
  getKanriList = async (params: TKenkoSindanKanriListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKenkoSindanKanriListGetRes[]>> =
        await this.getInner(`/employee/kenkosindanlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 健康診断情報取得
   *
   * @param id 健康診断管理ID
   * @memberof KenkoSindanService
   */
  get = async (id: number | string, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TKenkoSindanKanriGetRes>> =
        await this.getInner(`/employee/kenkosindanlist/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 健康診断削除
   *
   * @param {string} modifiedDt
   * @memberof KenkoSindanService
   */
  deleteKenkoSindan = async (id: number, modifiedDt: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `/employee/kenkosindanlist/${id}`,
        {
          更新日時: modifiedDt,
        }
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 健康診断更新
   *
   * @param {TKenkoSindanKanriPutReq} data
   * @memberof KenkoSindanService
   */
  putKenkoSindan = async (id: number, data: TKenkoSindanKanriPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/employee/kenkosindanlist/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 健康診断登録
   *
   * @param {TKenkoSindanKanriPostReq} data
   * @memberof KenkoSindanService
   */
  postKenkoSindan = async (data: TKenkoSindanKanriPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/employee/kenkosindanlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
